module.exports = __webpack_public_path__ + "img/trulead-icon-isometric.2d21ffc4.svg";